import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import PayoutsServiceTable from './payoutsServiceTable';
import PayoutsProductTable from './payoutsProductTable';
import {
  getPayoutReportNoCommissionSplits,
} from '../selectors';
import {
  activeShopCashTipsEnabled,
  activeShopGiftCardTipsEnabled,
  canUseGiftCards,
} from '../../../auth/selectors';
import { timeTrackingFlagEnabled } from '../../timeTracker/selectors';

const PayoutsReport = ({
  payoutReport: { serviceReport, productReport },
  showGiftCards,
  cashTipsEnabled,
  giftCardTipsEnabled,
  timeTrackingEnabled,
}) => (
  <div>
    <div display-if={!serviceReport.length && !productReport.length}>No data for selected date range and filters</div>
    <h3 className="u-mb-">Services</h3>
    <PayoutsServiceTable
      barberReports={serviceReport}
      showGiftCards={showGiftCards}
      cashTipsEnabled={cashTipsEnabled}
      giftCardTipsEnabled={giftCardTipsEnabled}
      timeTrackingEnabled={timeTrackingEnabled}
    />
    <h3 className="u-mt u-mb-">Products</h3>
    <PayoutsProductTable
      barberReports={productReport}
      showGiftCards={showGiftCards}
      timeTrackingEnabled={timeTrackingEnabled}
    />
  </div>
);

const mapStateToProps = state => ({
  payoutReport: getPayoutReportNoCommissionSplits(state),
  showGiftCards: canUseGiftCards(state),
  cashTipsEnabled: activeShopCashTipsEnabled(state),
  giftCardTipsEnabled: activeShopGiftCardTipsEnabled(state),
  timeTrackingEnabled: timeTrackingFlagEnabled(state),
});

PayoutsReport.propTypes = {
  payoutReport: PropTypes.object.isRequired,
  showGiftCards: PropTypes.bool.isRequired,
  cashTipsEnabled: PropTypes.bool.isRequired,
  giftCardTipsEnabled: PropTypes.bool.isRequired,
  timeTrackingEnabled: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(PayoutsReport);
